import axios from "axios";
import { Preferences } from "@capacitor/preferences";

const API = axios.create({
  baseURL: "https://api.joss-serveur.duckdns.org/api",
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// ===============================
// TOKEN SUR CHAQUE REQUÊTE
// ===============================
API.interceptors.request.use(
  async (config) => {
    const { value: token } = await Preferences.get({ key: "token" });

    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ===============================
// REFRESH AUTOMATIQUE SI 401
// ===============================
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status !== 401 ||
      originalRequest._retry ||
      originalRequest.url.includes("/users/login") ||
      originalRequest.url.includes("/users/refresh-token")
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return API(originalRequest);
        })
        .catch((err) => Promise.reject(err));
    }

    isRefreshing = true;

    try {
      const { value: refreshToken } = await Preferences.get({
        key: "refreshToken",
      });

      if (!refreshToken) {
        throw new Error("Refresh token absent");
      }

      const res = await axios.post(
        "https://api.joss-serveur.duckdns.org/api/users/refresh-token",
        { refreshToken }
      );

      const newToken = res.data.token;

      await Preferences.set({ key: "token", value: newToken });
      localStorage.setItem("token", newToken);

      if (res.data.user) {
        localStorage.setItem("user", JSON.stringify(res.data.user));
      }

      API.defaults.headers.common.Authorization = `Bearer ${newToken}`;

      processQueue(null, newToken);

      originalRequest.headers.Authorization = `Bearer ${newToken}`;

      return API(originalRequest);
    } catch (refreshError) {
      processQueue(refreshError, null);

      await Preferences.remove({ key: "token" });
      await Preferences.remove({ key: "refreshToken" });

      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");

      window.location.href = "/login";

      return Promise.reject(refreshError);
    } finally {
      isRefreshing = false;
    }
  }
);

export default API;